import { useQuery } from 'react-query';
import { network } from 'services/network';

const getLargestDeletedActivitiesTableData = (params) => {
    const payload = {
        compareVersionId: params.compareVersionId,
        contractId: params.contractId,
        latestVersionId: params.latestVersionId,
        projectId: params.projectId,
        filter: params.filterData,
    };
    return network
        .post('api/bo/getLongestDeletedActivities', payload)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw error;
        });
};

export const useQueryLargestDeletedActivitiesTableData = (params) => {
    return useQuery(['largestDeletedActivitiesTableData', params], () => getLargestDeletedActivitiesTableData(params), {
        enabled: Boolean(params.compareVersionId) && Boolean(params.latestVersionId),
    });
};
